// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".QMkedxlaUtfnjrnhUrrB7w\\=\\= {\n  display: flex;\n  align-self: flex-start;\n  margin: 1rem 0 0 1rem;\n}\n.KyKTyP6x1CWBYZNdK5qhDA\\=\\= {\n  margin-left: 10%;\n}\n", "",{"version":3,"sources":["webpack://./src/components/ViewClosedObjectives/ViewCloseObjectives.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".breadcrumbs_wrapper {\n  display: flex;\n  align-self: flex-start;\n  margin: 1rem 0 0 1rem;\n}\n.back {\n  margin-left: 10%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breadcrumbs_wrapper": "QMkedxlaUtfnjrnhUrrB7w==",
	"back": "KyKTyP6x1CWBYZNdK5qhDA=="
};
export default ___CSS_LOADER_EXPORT___;
